import { render, staticRenderFns } from "./SettlementEdit.vue?vue&type=template&id=0bbfad85&scoped=true&"
import script from "./SettlementEdit.vue?vue&type=script&lang=js&"
export * from "./SettlementEdit.vue?vue&type=script&lang=js&"
import style0 from "./SettlementEdit.vue?vue&type=style&index=0&id=0bbfad85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbfad85",
  null
  
)

export default component.exports